export const isEmpty = (text: string | undefined) => {
  const t = text?.trim();
  return t === "" || t === undefined || t === null;
};
